import { render, staticRenderFns } from "./fccGestaoCadastrosTipoContato.vue?vue&type=template&id=3234ed7c"
import script from "./fccGestaoCadastrosTipoContato.vue?vue&type=script&lang=js"
export * from "./fccGestaoCadastrosTipoContato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports